import { FC, useState } from 'react';
import { ITags } from '../../../../../../../../../types/bussines';
import { DeleteTrashCanIcon } from '../../../../../../../../../assets/images/blogModule';
import { BlackCheckIcon } from '../../../../../../../../../assets/images/countryList';

export interface ITagsOptions {
  tagOption: ITags;
  selectedItem?: boolean;
  deleteOrganizationTag: (option: ITags) => void;
  handleSelectOption: () => void;
  removeTagInListOpenModal: (option: ITags) => void;
}

const TagsOptions: FC<ITagsOptions> = ({
  tagOption,
  selectedItem,
  deleteOrganizationTag,
  handleSelectOption,
  removeTagInListOpenModal
}: ITagsOptions) => {
  const [localSelection, setLocalSelection] = useState<boolean>(false);

  const selectTag = selectedItem || localSelection;
  return (
    <div className="optionContainer">
      <div
        className="checkAndNameContainer"
        onClick={() => {
          if (selectTag) {
            deleteOrganizationTag(tagOption);
            setLocalSelection(false);
          } else {
            setLocalSelection(true);
            handleSelectOption();
          }
        }}
      >
        <div className="checkTagContainer">{selectTag ? <BlackCheckIcon /> : <div className="noSelectTag" />} </div>
        {tagOption?.name}
      </div>
      <div
        className="trashIconContainer"
        onClick={() => {
          removeTagInListOpenModal(tagOption);
        }}
      >
        <DeleteTrashCanIcon />
      </div>
    </div>
  );
};

export default TagsOptions;
